import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { ApiCoverageGroups } from '@bhtp-client-api/base';
import { Coverage } from './../../models/coverages/coverage.model';

@Component({
    selector: 'coverage-drawer',
    template: require('./coverage-drawer.component.html')
})
export class CoverageDrawerComponent implements OnChanges {
    @Input() public coverages: ApiCoverageGroups;
    @Input() public documentUrl: string;

    private standardCoverages: Array<Coverage>;
    private extraCoverages: Array<Coverage>;
    private optionalCoverages: Array<Coverage>;
    private buttonText: string;
    private showingCoverages: boolean;

    constructor() {
        this.buttonText = 'View Coverages';
        this.showingCoverages = false;
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['coverages'] && this.coverages) {
            this.standardCoverages = Coverage.createCoverages(this.coverages.included, ['standard'], true);
            this.extraCoverages = Coverage.createCoverages(this.coverages.included, ['extra', 'extra upgrade'], true);
            this.optionalCoverages = Coverage.createCoverages(this.coverages.optional, ['upgrade'], true);
        }
    }

    public toggleDetails(): void {
        this.showingCoverages = !this.showingCoverages;
        if (this.showingCoverages) {
            this.buttonText = 'Hide Coverages';
        }
        else {
            this.buttonText = 'View Coverages';
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/components/coverages/coverage-drawer.component.ts